import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { CustomMuiThemeProvider } from 'theme/CustomMuiThemeProvider';
import { DevicesTab } from './components/DevicesTab';
import { TabletsTab } from './components/TabletsTab';

enum StatusTab {
  Devices,
  Tablets,
}

const DevicesTabletsStatusContent = (): JSX.Element => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState(StatusTab.Devices);

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 115px)',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        bgcolor: 'background.default',
      }}
    >
      <Typography
        variant="h6"
        fontWeight={700}
        color="text.primary"
        sx={{ px: 2.5, pt: 2 }}
      >
        {t('devices_tablets_status_title')}
      </Typography>
      <Tabs
        value={activeTab}
        onChange={(_e, value: StatusTab) => {
          setActiveTab(value);
        }}
        sx={{
          px: 2.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Tab label={t('devices_tab')} value={StatusTab.Devices} />
        <Tab label={t('tablets_tab')} value={StatusTab.Tablets} />
      </Tabs>
      <Box sx={{ flex: 1, minWidth: 0, p: 2.5 }}>
        <Box
          sx={{
            display: activeTab === StatusTab.Devices ? 'block' : 'none',
            minWidth: 0,
          }}
        >
          <DevicesTab />
        </Box>
        <Box
          sx={{
            display: activeTab === StatusTab.Tablets ? 'block' : 'none',
            minWidth: 0,
          }}
        >
          <TabletsTab />
        </Box>
      </Box>
    </Box>
  );
};

export const DevicesTabletsStatusView = (): JSX.Element => (
  <CustomMuiThemeProvider>
    <DevicesTabletsStatusContent />
  </CustomMuiThemeProvider>
);
